<template>
  <zt-modal :fullscreen="isMobile" :active="isActiveModalForgotPassword"
    :title="$t('message.loginComponent.login.helpTitle')" @close="closeDialog" max-width="600px">

    <template>
      <div class="modal-help-body">
        <v-expansion-panel>
          <v-expansion-panel-content>
            <template v-slot:actions>
              <zt-icon name="angle-right-solid" />
            </template>
            <template v-slot:header>
              <div class="text-zt-dark-500">{{ $t('message.loginComponent.login.helpFaq4') }}</div>
            </template>
            <v-card>
              <v-card-text class="text-zt-dark-500">
                En <a href="https://www.sichern.com/" target="_blank" rel="noopener noreferrer">sichern.com.ar</a>{{
                  $t('message.loginComponent.login.helpAnswer41') }}<br />
                {{ $t('message.loginComponent.login.helpAnswer42') }}
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
          <v-expansion-panel-content>
            <template v-slot:actions>
              <zt-icon name="angle-right-solid" />
            </template>
            <template v-slot:header>
              <div class="text-zt-dark-500">{{ $t('message.loginComponent.login.helpFaq5') }}</div>
            </template>
            <v-card>
              <v-card-text class="text-zt-dark-500">
                En <a href="https://www.sichern.com/" target="_blank" rel="noopener noreferrer">sichern.com.ar</a> {{
                  $t('message.loginComponent.login.helpAnswer511') }}<br />
                {{ $t('message.loginComponent.login.helpAnswer522') }}<a
                  href="https://mail.google.com/mail/u/0/#inbox?compose=new" target="_blank"
                  rel="noopener noreferrer">{{
                    $t('message.loginComponent.login.rrhh') }}</a>. {{ $t('message.loginComponent.login.helpAnswer533') }}
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </div>
    </template>
  </zt-modal>
</template>

<script>
import { mutation } from "@/modules/Auth/hooks/activeForgotPasswordModal";
import { useWindowResize } from '@sichern/ui-elements'

export default {
  name: 'ztAuthForgotPasswordHelpDialog',
  props: {
    isActiveModalForgotPassword: {
      type: Boolean,
      default: false
    }
  },
  provide: { mutation },
  data() {
    return {
      year: new Date().getFullYear(),
      windowResize: useWindowResize(this),
    }
  },
  computed: {
    isMobile() {
      return this.windowResize.width < 1024
    }
  },
  methods: {
    closeDialog() {
      mutation.setActiveForgotPasswordModal(false)
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../../public/assets/scss/_config.scss';

.modal-help-body {
  height: 447px;
  overflow-y: auto;
}

@media all and (max-width: 1024px) {
  .modal-help-body {
    height: 100%;
  }
}

::v-deep {
  .v-expansion-panel {
    box-shadow: 0 2px 1px -1px rgba(0, 0, 0, .1), 0 1px 1px 0 rgba(0, 0, 0, .1), 0 1px 3px 0 rgba(0, 0, 0, .1);
  }

  .v-expansion-panel__header {
    background: #f6f6f6;
    padding: 12px 28px;
    font-size: 1rem;
  }

  .v-expansion-panel__container--active {
    .v-expansion-panel__header {
      >div {
        color: $primary-color-200;
        font-weight: bold;
      }

      .v-expansion-panel__header__icon {
        transform: rotate(90deg);
      }
    }

    .v-expansion-panel__body {
      .v-card__text {
        box-shadow: inset 0 8px 8px -8px rgba(0, 0, 0, .3), inset 0 -8px 8px -8px rgba(0, 0, 0, .3);
        padding: 28px;
        font-size: 1rem;
      }
    }
  }
}
</style>